import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import Offcanvas from 'react-bootstrap/Offcanvas';
import AddLocation from '../../components/forms/addLocation';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/actions';
import { AiOutlineEdit } from 'react-icons/ai';

let updateInterval = ""
let Locations = () => {
   let locations = useSelector(data => data.locations);
   let dispatch = useDispatch();

   const [show, setShow] = useState(false);
   const [location, setLocation] = useState({});


   let updateList = async (data, remove = false) => {
      let list = locations.data;
      if (remove) {
         list = list.filter(item => item._id != data?._id);
      } else {
         if (location?._id) {
            let index = await list.findIndex(item => item?._id == data?._id);
            if (index > -1) {
               list[index] = data
            }
         } else {
            list = [data, ...list]
         }
      }
      dispatch(Actions.addLocationsList(list));
      setShow(false);
   }

   let editData = (data) => {
      setLocation(data);
      setShow(true);
   }

   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Shipping Locations</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="bg-white p-3 overflow-hidden">
                        <div className="d-flex justify-content-between border-bottom pb-2">
                           <div>
                              <h4>Shipping Locations</h4>
                           </div>
                           <div>
                              <button className='btn rounded-0 btn-dark'
                                 onClick={() => { editData({}); setShow(true) }}
                              >Add New</button>
                           </div>
                        </div>
                        <br />
                        {(locations.loading || !locations.loaded || locations.data.length == 0) ? (
                           <div className='pageSimpleLoader'>
                              {locations.loaded ? "No record found" : "Loading..."}
                           </div>
                        ) : (
                           <div className='table-responsive'>
                              <table className='table'>
                                 <thead>
                                    <tr>
                                       <th>#</th>
                                       <th>Location</th>
                                       <th>Price</th>
                                       <th>Action</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {locations?.data?.map((data, index) => {
                                       return (
                                          <tr key={index} >
                                             <td>{index + 1}</td>
                                             <td>{data?.locationTitle}</td>
                                             <td>{data?.deliveryCost}</td>
                                             <td >
                                                <AiOutlineEdit onClick={() => editData(data)} className='pointer' />
                                             </td>
                                          </tr>
                                       );
                                    })}
                                 </tbody>
                              </table>
                           </div>
                        )}
                        <br />
                        <br />
                     </div>
                  </div>
               </div>

            </div>
         </DashboardLayout>
         <Offcanvas show={show} placement="end" onHide={() => setShow(false)}>
            <Offcanvas.Header closeButton>
               <Offcanvas.Title>Add Locations</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
               <AddLocation updateList={updateList} data={location} />
            </Offcanvas.Body>
         </Offcanvas>
      </>
   )
}

export default Locations